import { useTranslation } from 'react-i18next';

export default function FinalCTA() {
  const { t } = useTranslation('common');

  const handleConsultation = () => {
    window.location.href = 'mailto:info@id.iij.com?subject=Consultation Request - Factory Connectivity Solution';
  };

  return (
    <section className="py-24 px-8 bg-slate-900 text-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          {t('finalCta.title')}
        </h2>
        <p className="text-xl text-gray-300 mb-10 leading-relaxed">
          {t('finalCta.subtitle')}
        </p>
        <button 
          onClick={handleConsultation}
          className="bg-red-700 hover:bg-red-800 text-white px-12 py-5 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
        >
          {t('finalCta.button')}
        </button>
      </div>
    </section>
  );
}
